module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "epa-ch4emission-yeargrid-v2express.thumbnails.petroleum.refining.annual.a08464d9.png";